var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"planRelationDialog",attrs:{"title":"关联考试计划","top":"5vh","visible":_vm.visible,"width":"620px"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('table-list',{attrs:{"data":_vm.planList,"options":{ border: true, maxHeight: '585px' },"columns":_vm.columns(this)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }